

































































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
/* component */
import PageTitle from '@/app/components/Common/PageTitle.vue'

@Component({
  components: {
    PageTitle
  }
})
export default class GroupSearch extends Vue {
  private search: string = this.$store.state.groupState.searchText
  @Prop() private total!: number

  private doGroupSearch () {
    /* キーワード検索 */
    this.$store.commit('groupState/setSearchText', this.search)

    this.$emit('search-list')
  }

  /* リセット */
  private doClear () {
    this.search = ''

    // stateリセット
    this.$store.commit('groupState/setSearchText', '')
    this.$store.commit('groupState/setSortName', 'group_name')
    this.$store.commit('groupState/setSortAsc', true)

    this.$emit('reset-list')
  }
}
